// Campos mínimos do cadastro de cliente — mesma regra do backend (routes/clientes.js).
// Data de nascimento só é exigida de pessoa física (CNPJ = 14 dígitos fica dispensado).
export const CAMPOS_OBRIGATORIOS = ['nome', 'cpf_cnpj', 'data_nascimento', 'telefone', 'endereco', 'numero', 'bairro', 'cidade', 'estado', 'cep'];

export const ehCnpj = (doc) => String(doc || '').replace(/\D/g, '').length === 14;

export const camposFaltando = (form) => CAMPOS_OBRIGATORIOS.filter(c => {
  if (c === 'data_nascimento' && ehCnpj(form.cpf_cnpj)) return false;
  return String(form[c] == null ? '' : form[c]).trim() === '';
});

export const ehObrigatorio = (campo, form) => CAMPOS_OBRIGATORIOS.includes(campo) && !(campo === 'data_nascimento' && ehCnpj(form.cpf_cnpj));

export const MSG_OBRIGATORIOS = 'Preencha todos os campos obrigatórios';
